module.exports = __webpack_public_path__ + "static/media/photocell-conn.2fe3c9a1.jpg";